import { useState, useEffect } from "react";

import { apiInstance } from "@/shared/api";
import { Quote } from "@/entities/quote";
import { PaginatedResponse } from "@/shared/types";

export const useGetRandomQuote = ({ open }: { open: boolean }) => {
  const [randomQuote, setRandomQuote] = useState<Quote | null>(null);

  useEffect(() => {
    const quoteCount = 210;
    const randomQuoteIndex = Math.floor(Math.random() * quoteCount);

    const randomQuote = async () => {
      const { data } = await apiInstance.get<PaginatedResponse<Quote>>(
        "/quotes",
        {
          currentPage: randomQuoteIndex,
          pageSize: 1,
        },
        true,
      );

      return data;
    };

    if (open === true) {
      randomQuote().then((quotes) => {
        if (quotes.data.length > 0) {
          const quote = quotes.data[0];
          setRandomQuote(quote);
        }
      });
    }
  }, [open]);

  return { randomQuote };
};
